import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../api/axiosConfig';
import TestPageComponent from '../../components/tests/TestPageComponent';

interface Option {
  label: string;
  value: number;
}

interface Question {
  id: string;
  question: string;
  options: Option[];
}

interface TestData {
  id: string;
  title: string;
  description: string;
  questions: Question[];
  scoringMethod: string;
  reverseScoreIndices: number[];
  maxScorePerQuestion: number;
}

const GenericTestPage: React.FC = () => {
  const { testId } = useParams<{ testId: string }>();
  const navigate = useNavigate();
  const [testData, setTestData] = useState<TestData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTestData = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(`/api/psych-tests/${testId}`);
        setTestData(response.data);
      } catch (err) {
        console.error('Failed to fetch test data:', err);
        setError('테스트 정보를 불러오는 데 실패했습니다.');
      } finally {
        setIsLoading(false);
      }
    };

    if (testId) {
      fetchTestData();
    }
  }, [testId]);

  const calculateScore = (answers: number[]) => {
    if (!testData) return 0;

    return answers.reduce((sum, val, index) => {
      // 역채점 문항인지 확인
      if (testData.reverseScoreIndices && testData.reverseScoreIndices.includes(index)) {
        return sum + (testData.maxScorePerQuestion - val);
      }
      return sum + val;
    }, 0);
  };

  if (isLoading) return <div className="loading-container">로딩 중...</div>;
  if (error || !testData) return <div className="error-container">{error || '데이터를 찾을 수 없습니다.'}</div>;

  return (
    <TestPageComponent
      testType={testData.id}
      title={testData.title}
      description={testData.description}
      questions={testData.questions}
      calculateScore={calculateScore}
    />
  );
};

export default GenericTestPage;
